import React, { createContext, useContext, useState } from "react";
import axiosInstance, { handleApiError } from "../services/axiosService";
import { useTreeContext } from "./TreeDataContext";
import { useAppBlocksContext } from "./AppBlocksContext";
import { createChecksum } from "../commonFunctions/fileFolderConfig";
import { useAppOrgContext } from "./AppOrgContext";
import { CUSTOM_REACT_COMPONENT_API } from "../Api/Templates";
import { getTreeDataForSqlTemplates, getTreeDataForTemplates } from "../utils/treeData/treeDataUtils";
const TemplateContextApi = createContext();
const useTemplateContext = () => useContext(TemplateContextApi);
const TemplateContext = ({ children }) => {
  const [selectedTemplate, setSelectedTemplate] = useState({
    id: "",
    name: "",
    parentData: ""
  });

  // data for sms, wa and email
  const [templateData, setTemplateData] = useState({
    subject: "",
    body: "",
    table_name: "",
    fields: "",
    name: "",
    sql_query: ""
  });
  //for updating fields array for rdbms in textarea
  const [fieldsArr, setFieldsArr] = useState([]);

  const { currentChecksum } = useAppOrgContext();
  const { setTemplateExplorerData, setSqlTemplateExplorerData } = useTreeContext();
  const { getDetailviewConfig } = useAppBlocksContext();
  const [designData, setDesignData] = useState();
  const [reactComponent, setReactComponents] = useState([]);

  //React components data is necessary in details view element bar
  const getReactComponents = async () => {
    try {
      const { data } = await axiosInstance.get(CUSTOM_REACT_COMPONENT_API);
      setReactComponents(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  const fetchAllTemplates = async () => {
    const endpoints = [
      "/email",
      "/sms",
      "/pdf_template",
      // "/sysconfigs/type/detailsview",
      // "/rdbms",
      "/masterdata",
      "/googledoc",
      "/access-templates",
      "/mongo-template",
      "/recordview-template",
      "/exceldoc",
      // "/postgres",
      "/ocr",
      CUSTOM_REACT_COMPONENT_API,
      "/ai-assistant-template",
      "/api-forwarding-template"
    ];

    const requests = endpoints.map((endpoint) => axiosInstance.get(endpoint));
    const responses = await Promise.all(requests);
    const responseData = responses.map((response) => response.data);
    const [
      emailData,
      smsData,
      daData,
      // detailsviewTemplate,
      // rdbmsData,
      masterData,
      googleDocData,
      accessTemplateData,
      mongoTemplateData,
      recordviewTemplateData,
      excelTemplate,
      // postgresData,
      ocrData,
      reactCompTemplate,
      aiAssistantTemplate,
      apiForwardingTemplate
    ] = responseData;

    const treeData = getTreeDataForTemplates([
      emailData,
      smsData,
      // detailsviewTemplate,
      // rdbmsData,
      masterData,
      daData,
      googleDocData,
      accessTemplateData,
      mongoTemplateData,
      recordviewTemplateData,
      excelTemplate,
      // postgresData,
      ocrData,
      reactCompTemplate,
      aiAssistantTemplate,
      apiForwardingTemplate
    ]);

    setTemplateExplorerData(treeData);

    return {
      emailData,
      smsData,
      // detailsviewTemplate,
      // rdbmsData,
      masterData,
      daData,
      googleDocData,
      accessTemplateData,
      mongoTemplateData,
      recordviewTemplateData,
      excelTemplate,
      // postgresData,
      ocrData,
      reactCompTemplate,
      aiAssistantTemplate,
      apiForwardingTemplate
    };
  };

  const fetchSqlTemplates = async () => {
    const endpoints = ["/rdbms", "/postgres"];

    const requests = endpoints.map((endpoint) => axiosInstance.get(endpoint));
    const responses = await Promise.all(requests);
    const responseData = responses.map((response) => response.data);
    const [rdbmsData, postgresData] = responseData;

    const treeData = getTreeDataForSqlTemplates([rdbmsData, postgresData]);

    setSqlTemplateExplorerData(treeData);

    return {
      rdbmsData,
      postgresData
    };
  };

  const getTemplateConfig = () => {
    if (selectedTemplate.parentData === "detailsviewTemplate") {
      const data = getDetailviewConfig();
      return {
        config: {
          elements: data.elements,
          unique_ids: data.unique_ids,
          image_data: designData.image_data
        }
      };
    } else {
      return templateData;
    }
  };

  const handleSaveTemplate = async () => {
    try {
      const config = getTemplateConfig();
      let newMessage;
      if (selectedTemplate.parentData === "detailsviewTemplate") {
        const { message } = await axiosInstance.put(`/sysconfigs/${selectedTemplate.id}`, config);
        newMessage = message;
      } else if (
        // selectedTemplate.parentData === "rdbms" ||
        selectedTemplate.parentData === "mongo-template" ||
        selectedTemplate.parentData === "recordview-template"
      ) {
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, {
          ...config,
          fields: config.fields === null ? [] : fieldsArr,
          // fields: config.fields === "null" ? [] : JSON.parse(fieldsArr),
          name: selectedTemplate.name
        });
        newMessage = message;
      } else if (selectedTemplate.parentData === "exceldoc") {
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, {
          ...config,
          // excel_variables: config.excel_variables === "null" ? [] : JSON.parse(fieldsArr),
          // excel_variables: config.excel_variables === "null" ? [] : fieldsArr,
          name: selectedTemplate.name
        });
        newMessage = message;
      } else if (selectedTemplate.parentData === "masterdata") {
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, config);
        newMessage = message;
      } else if (selectedTemplate.parentData === "ocr") {
        // Handle OCR template data
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, {
          ...config,
          questions: config.questions === null ? [] : config.questions,
          name: selectedTemplate.name
        });
        newMessage = message;
      } else if (selectedTemplate.parentData === "custom-component") {
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, config);
        newMessage = message;
      } else if (selectedTemplate.parentData === "ai-assistant-template") {
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, {
          ...config,
          ai_variables: config.ai_variables === "null" ? [] : JSON.parse(fieldsArr),
          name: selectedTemplate.name
        });
        newMessage = message;
      } else if (selectedTemplate.parentData === "api-forwarding-template") {
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, config);
        newMessage = message;
      } else {
        const { message } = await axiosInstance.patch(`/${selectedTemplate.parentData}/${selectedTemplate.id}`, {
          ...config,
          name: selectedTemplate.name
        });
        newMessage = message;
      }

      const newChecksum = createChecksum(config);
      currentChecksum.current = newChecksum;
      return { data: config, message: newMessage };
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  return (
    <TemplateContextApi.Provider
      value={{
        selectedTemplate,
        templateData,
        fieldsArr,
        designData,
        setDesignData,
        setFieldsArr,
        setTemplateData,
        setSelectedTemplate,
        getTemplateConfig,
        handleSaveTemplate,
        fetchAllTemplates,
        getReactComponents,
        reactComponent,
        fetchSqlTemplates
      }}
    >
      {children}
    </TemplateContextApi.Provider>
  );
};

export default TemplateContext;
export { useTemplateContext };
